import { useSpinToWin } from 'features';
import { LandingPage } from './LandingPage';
import { ResultsPage } from './ResultsPage';
import { Fade } from '@telescope/cassini-ui';

export const SpinTheWheelGame = () => {
  const { displayResults } = useSpinToWin();

  return (
    <>
      <Fade in={!displayResults} transition={{ exit: { duration: 0.2 } }} unmountOnExit={true}>
        <LandingPage />
      </Fade>
      
      <Fade in={displayResults} transition={{ enter: { delay: 0.2, duration: 0.3 } }} unmountOnExit={true}>
        <ResultsPage />
      </Fade>
    </>
  )
}